
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'esocial_tabela',
        label: 'Layout',
        option: {
            key: 'id',
            label: 'esocial',
            value: 'object'
        },
        info: 'Selecione um LAYOUT para gerar os arquivos XML',
        clearable: true,
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/esocial/_form/layout.js